export default __webpack_public_path__ + "static/mejix-ef2ca7b32dc5bd6d46627fd9aa7e8516.svg";